import { deepMerge } from '@/utils/object';
import addAnnouncement from './addAnnouncement';

export default function([primaryChart, secondaryChart]) {
  for (const serie of primaryChart.series) {
    serie.name = serie.title;
  }
  const { dates = [], options = {} } = primaryChart;
  let primaryChartWithAnnouncement = addAnnouncement(primaryChart);
  if (secondaryChart) {
    const secondaryChartWithAnnouncement = addAnnouncement(secondaryChart);
    const { options: secondaryOptions = {} } = secondaryChart;
    return {
      charts: {
        primaryChart: primaryChartWithAnnouncement,
        secondaryChart: secondaryChartWithAnnouncement,
      },
      dates,
      options: deepMerge(options, secondaryOptions),
    };
  }
  return {
    charts: { primaryChart: primaryChartWithAnnouncement },
    dates,
    options,
  };
}
